import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { scrollToAnchor } from "../utils/anchor";

const MentionsLegales = () => {
  useEffect(() => {
    scrollToAnchor("mleg");
  }, []);
  return (
    <div className="pageML" id="mleg">
      <h1>MENTIONS LEGALES</h1>
      <h2>1.Présentation du site</h2>
      <p>
        En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour la
        confiance dans l’économie numérique, il est précisé aux utilisateurs du
        site www.cindy-naturopathe.com l’identité des différents intervenants
        dans le cadre de sa réalisation et de son suivi :
        <br /> Propriétaire : Cindy Pantoustier
        <br />
        Créateur : Cindy Pantoustier
        <br />
        Responsable publication : Cindy Pantoustier
        – contact@cindy-naturopathe.com‍
        <br />
        Programmeur : Davy SEBBAH{" "}
        <Link to="mailto:d.sebbah@yahoo.fr" className="linksML1">
          Envoyer un e-mail à d.sebbah@yahoo.fr
        </Link>
        <br />
        <Link
          to="https://portfolio-fbdcb.web.app/"
          rel="noopener noreferrer"
          target="_blanck"
          className="linksML2"
        >
          Portfolio de Davy SEBBAH - Créateur d'applications et de sites Web{" "}
        </Link>
        <Link
          to="https://cj-group.co/about-us/"
          rel="noopener noreferrer"
          target="_blanck"
          className="linksML3"
        >
          en partenariat avec le groupe CJ
        </Link>
        <br />
        Hébergeur: OVH - 2 rue Kellermann – BP 80157 59053 ROUBAIX CEDEX 1
      </p>

      <h2>
        2.Conditions générales d’utilisation du site et des services proposés
      </h2>
      <p>
        L’utilisation du site www.cindy-naturopathe.com implique que
        l’acceptation pleine et entière des conditions générales d’utilisation
        ci-après décrites.
        <br /> Ces conditions d’utilisation sont susceptibles d’être modifiées
        ou complétées à tout moment, les utilisateurs du
        site www.cindy-naturopathe. com sont donc invités à les consulter de
        manière régulière.
        <br />
        Ce site est normalement accessible à tout moment aux utilisateurs.
        <br /> Une interruption pour raison de maintenance technique peut
        toutefois être décidée par Cindy Pantoustier, qui s’efforcera alors de
        communiquer préalablement aux utilisateurs les dates et heures de
        l’intervention.
        <br />
        Le site www.cindy-naturopathe.com est mis à jour régulièrement par Cindy
        Pantoustier.
        <br />
        De la même façon, les mentions légales peuvent être modifiées à tout
        moment : elles s’imposent néanmoins à l’utilisateur qui est invité à s’y
        référer le plus souvent possible afin d’en prendre
        connaissance.<br />www.cindy-naturopathe.com propose des articles, vidéos,
        ainsi que de l’actualité sur la santé et le bien-être dans un but
        purement informatif.
        <br />
        Selon les articles 10 de la Convention européenne des droits de l’Homme
        du 4 novembre 1950 et 11 de la Charte des droits fondamentaux de l’Union
        européenne de 2000 :« Toute personne a droit à la liberté d’expression.
        <br /> Ce droit comprend la liberté d’opinion et la liberté de recevoir
        ou de communiquer des informations ou des idées sans qu’il puisse y
        avoir ingérence d’autorités publiques et sans considération de
        frontières… »
        <br />
        Cindy Pantoustier ne propose sur ce site que des conseils généraux
        d’hygiène de vie, et ce, dans un but de simple vulgarisation.
        <br />
        L’utilisation des informations fournies sur ce site s’effectue sous la
        pleine et entière responsabilité de l’utilisateur au même titre que
        l’utilisation qu’il pourrait faire à partir de livres ou revues.
        <br />
        Et en aucun cas, Cindy Pantoustier ne pourra être rendue responsable de
        cette utilisation, ainsi que d’erreurs, d’inexactitudes ou d’omissions
        pouvant exister sur le site. 
      </p>

      <h2>3.Description des services fournis</h2>
      <p>
        Le site www.cindy-naturopathe.com a pour objet de fournir une
        information concernant l’ensemble des activités de l’entreprise.
        <br />
        Cindy Pantoustier s’efforce de fournir sur le
        site www.cindy-naturopathe.com des informations aussi précises que
        possible.
        <br /> Toutefois, elle ne pourra être tenue responsable des omissions,
        des inexactitudes et des carences dans la mise à jour, qu’elles soient
        de son fait ou du fait des tiers partenaires qui lui fournissent ces
        informations.
        <br />
        Toutes les informations indiquées sur le www.cindy-naturopathe.com  sont
        données à titre indicatif, et sont susceptibles d’évoluer.
        <br /> Par ailleurs, les renseignements figurant sur le
        site www.cindy-naturopathe.com ne sont pas exhaustifs.
        <br /> Ils sont donnés sous réserve de modifications ayant été apportées
        depuis leur mise en ligne.
      </p>
      <h2>4.Limitations contractuelles sur les données techniques</h2>
      <p>
        Le site utilise la technologie React.‍Le site Internet ne pourra être
        tenu responsable de dommages matériels liés à l’utilisation du site.
        <br /> De plus, l’utilisateur du site s’engage à accéder au site en
        utilisant un matériel récent, ne contenant pas de virus et avec un
        navigateur de dernière génération mis-à-jour.
      </p>
      <h2>5.Propriété intellectuelle et contrefaçons</h2>
      <p>
        Cindy Pantoustier est propriétaire des droits de propriété
        intellectuelle ou détient les droits d’usage sur tous les éléments
        accessibles sur le site, notamment les textes, images, graphismes, logo,
        icônes, sons, logiciels.Toute reproduction, représentation,
        modification, publication, adaptation de tout ou partie des éléments du
        site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf
        autorisation écrite préalable de Cindy Pantoustier.
        <br />
        Toute exploitation non autorisée du site ou de l’un quelconque des
        éléments qu’il contient, sera considérée comme constitutive d’une
        contrefaçon et poursuivie conformément aux dispositions des articles
        L.335-2 et suivants du Code de Propriété Intellectuelle.
      </p>
      <h2>6.Limitations de responsabilité</h2>
      <p>
        Cindy Pantoustier ne pourra être tenue responsable des dommages directs
        et indirects causés au matériel de l’utilisateur, lors de l’accès au
        site www.cindy-naturopathe.com et résultant soit de l’utilisation d’un
        matériel ne répondant pas aux spécifications indiquées au point 4, soit
        de l’apparition d’un bug ou d’une incompatibilité.
        <br />
        Cindy Pantoustier ne pourra également être tenue responsable des
        dommages indirects (tels par exemple qu’une perte de marché ou perte
        d’une chance) consécutifs à l’utilisation du
        site www.cindy-naturopathe.com .Des espaces interactifs (possibilité de
        poser des questions dans l’espace contact) sont à la disposition des
        utilisateurs.
        <br /> Cindy Pantoustier se réserve le droit de supprimer, sans mise en
        demeure préalable, tout contenu déposé dans cet espace qui
        contreviendrait à la législation applicable en France, en particulier
        aux dispositions relatives à la protection des données.Le cas échéant,
        Cindy Pantoustier se réserve également la possibilité de mettre en cause
        la responsabilité civile et/ou pénale de l’utilisateur, notamment en cas
        de message à caractère raciste, injurieux, diffamant, ou pornographique,
        quel que soit le support utilisé (texte, photographie…).
      </p>
      <h2>7.Gestion des données personnelles</h2>
      <p>
        En France, les données personnelles sont notamment protégées par la loi
        n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août 2004, l’article
        L. 226-13 du Code pénal et la Directive Européenne du24 octobre 1995.
        <br />A l’occasion de l’utilisation du site  www.cindy-naturopathe.com,
        peuvent êtres recueillies : l’URL des liens par l’intermédiaire desquels
        l’utilisateur a accédé au site www.cindy-naturopathe.com, le fournisseur
        d’accès de l’utilisateur, l’adresse de protocoleInternet (IP) de
        l’utilisateur.
        <br />
        En tout état de cause, Cindy Pantoustier ne collecte des informations
        personnelles relatives à l’utilisateur que pour le besoin de certains
        services proposés par le site www.cindy-naturopathe.com .
        <br />
        L’utilisateur fournit ces informations en toute connaissance de cause,
        notamment lorsqu’il procède par lui-même à leur saisie.
        <br />
        Il est alors précisé à l’utilisateur du site www.cindy-naturopathe.com
        l’obligation ou non de fournir ces informations.
        <br />
        Conformément aux dispositions des articles 38 et suivants de la loi
        78-17 du 6janvier 1978 relative à l’informatique, aux fichiers et aux
        libertés, tout utilisateur dispose d’un droit d’accès, de rectification
        et d’opposition aux données personnelles le concernant, en effectuant sa
        demande écrite et signée, accompagnée d’une copie du titre d’identité
        avec signature du titulaire de la pièce, en précisant l’adresse à
        laquelle la réponse doit être envoyée.Aucune information personnelle de
        l’utilisateur du site www.cindy-naturopathe.comn’est publiée à l’insu de
        l’utilisateur, échangée, transférée, cédée ou vendue sur un support
        quelconque à des tiers.
        <br /> Seule l’hypothèse du rachat de Cindy Pantoustier et de ses droits
        permettrait la transmission des dites informations à l’éventuel
        acquéreur qui serait à son tour tenu de la même obligation de
        conservation et de modification des données vis à vis de l ’utilisateur
        du site www.cindy-naturopathe.com.‍
        <br />
        Les bases de données sont protégées par les dispositions de la loi du1er
        juillet 1998 transposant la directive 96/9 du 11 mars 1996relative à la
        protection juridique des bases de données.
      </p>
      <h2>8.Liens hypertextes et cookies</h2>
      <p>
        Le site   www.cindy-naturopathe.com contient un certain nombre de liens
        hypertextes vers d’autres sites, mis en place avec l’autorisation de
        Cindy Pantoustier.
        <br />
        Cependant,Cindy Pantoustier n’a pas la possibilité de vérifier le
        contenu des sites ainsi visités, et n’assumera en conséquence aucune
        responsabilité de ce fait.
        <br />
        La navigation sur le site  www.cindy-naturopathe.com est susceptible de
        provoquer l’installation de cookie(s) sur l’ordinateur de l’utilisateur.
        <br />
        Un cookie est un fichier de petite taille, qui ne permet pas
        l’identification de l’utilisateur, mais qui enregistre des informations
        relatives à la navigation d’un ordinateur sur un site.
        <br /> Les données ainsi obtenues visent à faciliter la navigation
        ultérieure sur le site, et ont également vocation à permettre diverses
        mesures de fréquentation.
        <br />
        Le refus d’installation d’un cookie peut entraîner l’impossibilité
        d’accéder à certains services.
        <br /> L’utilisateur peut toutefois configurer son ordinateur de la
        manière suivante, pour refuser l’installation des cookies.
      </p>
      <h2>9.Droit applicable et attribution de juridiction</h2>
      <p>
        Tout litige en relation avec l’utilisation du
        site www.cindy-naturopathe.com est soumis au droit français.
        <br />
         Conformément aux articles L.616-1 et R.616-1 du code de la
        consommation, notre société a mis en place un dispositif de médiation de
        la consommation.
        <br /> L’entité de médiation retenue est : SASCNPM – MÉDIATION –
        CONSOMMATION.
        <br /> En cas de litige, le consommateur pourra déposer sa réclamation
        sur le site : http://cnpm-mediation-consommation.eu ou par voie postale
        en écrivant à:
        <br />
        CNPM– MÉDIATION – CONSOMMATION 27, avenue de la Libération – 42400
        SAINT-CHAMOND
      </p>
    </div>
  );
};

export default MentionsLegales;
